<div style="display: flex; height: 100%">
  <div style="display: flex; flex-direction: column; overflow: auto; width: 100%;">
    <div style="display: flex; flex-direction: column; padding: 20px; z-index: 1; ">
      <mat-toolbar color="primary" class="toolbar-over-card"
                   style="padding: 20px; align-items: center; justify-content: space-between;">
        <div><span>Third Party Applications</span></div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar party-card" *inRole="[roles.DeleteDocFeatureSet]">
        <mat-card-header class="card-header">
          <mat-card-title>Document Management System</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <lex-third-party-clio *inRole="[roles.DeleteDocFeatureSet]"></lex-third-party-clio>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" class="card-under-toolbar party-card">
        <mat-card-header class="card-header">
          <mat-card-title>AI Assistant</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <lex-third-party-open-ai></lex-third-party-open-ai>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
